module.exports = __webpack_public_path__ + "assets/img/wwt1.b0f6a06a.png";